export const env = {
    BASE_URL_ACCOUNT: "https://api-ecowash.tsp.com.vn/account/",
    API_ROOT: "https://api-ecowash.tsp.com.vn",
    CDN_URL: "https://cdn-ecowash.tsp.com.vn",
    OPS_PORTAL_URL: "https://ecowash.tsp.com.vn/"
}